// extracted by mini-css-extract-plugin
module.exports = {"fixedWidth":"NextAvailable_fixedWidth__HneCv","imageFixedSize":"NextAvailable_imageFixedSize__NIF0A"};